import { createAsyncThunk } from '@reduxjs/toolkit'
import SeasonSnapshot from './season-snapshot-model'
import {
  delete_seasonSnapshot,
  load_seasonSnapshots,
  store_seasonSnapshot,
} from './seasonSnapshot-service'

export const LoadSeasonSnapshotsAsync = createAsyncThunk<any, any>(
  'composer/load/seasonSnapshot',
  async (params: { uid: string }) => {
    return await load_seasonSnapshots(params)
  },
)

export const CreateSeasonSnapshotAsync = createAsyncThunk<any, any>(
  'composer/create/seasonSnapshot',
  async (params: SeasonSnapshot) => {
    return await store_seasonSnapshot(params)
  },
)

export const DeleteSeasonSnapshotAsync = createAsyncThunk<any, any>(
  'composer/delete/seasonSnapshot',
  async (params) => {
    return await delete_seasonSnapshot(params)
  },
)
